// extracted by mini-css-extract-plugin
export default {"container":"LabStatusOverview_container__pet77","percentage":"LabStatusOverview_percentage__zue4d"};